// Ticket Order Model
cv.TicketOrder = Backbone.RESTModel.extend({
  defaults: {
    amount: 0,
    first_name: "",
    last_name: "",
    email: "",
    line1: "",
    line2: "",
    city: "",
    state: "",
    zipcode: "",
    country: "US",
  },

  saveMap: {
    amount: "amount",
    first_name: "first_name",
    last_name: "last_name",
    email: "email",
    line1: "line1",
    line2: "line2",
    city: "city",
    state: "state",
    zipcode: "zipcode",
    country: "country",
    status: "status",
  },

  urlRoot: function () {
    return "/api/v2/ticket_orders";
  },

  initialize: function () {
    console.log("Ticket Order model initialized.");
  },
});
Cocktail.mixin(cv.TicketOrder, cv.mixins.SyncModel);

// Ticket Orders Collection
cv.TicketOrders = Backbone.Collection.extend({
  initialize: function () {
    console.log("Ticket Orders collection initialized.");
  },

  url: function () {
    return "/api/v2/ticket_orders?" + $.param(this.params);
  },

  model: cv.Donation,
});
Cocktail.mixin(cv.TicketOrders, cv.mixins.PaginateModel);
